import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { VisuallyHidden } from '@react-aria/visually-hidden';
import CloseIcon from '../../../shared/icons/icon-close.svg';
import HamburgerIcon from '../../../shared/icons/icon-hamburger.svg';


const MobileHamburgerButton = function MobileHamburgerButtonComponent(
  { drawerIsOpen, toggleDrawerOpen },
) {
  const triggerClass = classNames({
    'site-header__drawer-trigger': true,
    'site-header__drawer-trigger--open': drawerIsOpen,
  });

  const triggerText = drawerIsOpen ? 'close navigation drawer' : 'open navigation drawer';

  const handleEscape = ({ key }) => {
    if (key === 'Escape' && drawerIsOpen) {
      toggleDrawerOpen();
    }
  };

  return (
    <button
      type="button"
      className={triggerClass}
      onClick={toggleDrawerOpen}
      onKeyDown={handleEscape}
    >
      <VisuallyHidden>{triggerText}</VisuallyHidden>
      {
        drawerIsOpen ?
          <CloseIcon className="site-header__drawer-icon site-header__drawer-icon--close" /> :
          <HamburgerIcon className="site-header__drawer-icon site-header__drawer-icon--hamburger" />
      }
    </button>
  );
};

MobileHamburgerButton.propTypes = {
  drawerIsOpen: PropTypes.bool.isRequired,
  toggleDrawerOpen: PropTypes.func.isRequired,
};

export default MobileHamburgerButton;
